import { render } from "./Icarus.vue?vue&type=template&id=0b64ba14"
import script from "./Icarus.vue?vue&type=script&lang=js"
export * from "./Icarus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__